import { render, staticRenderFns } from "./PaymentRequirement.vue?vue&type=template&id=dc9313c6"
import script from "./PaymentRequirement.vue?vue&type=script&lang=js"
export * from "./PaymentRequirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports